import {
    HttpResponse,
    PlanItemModel,
    PlanItemBasicModel,
    QueryModel,
    RequestParams,
    PlanItemModelIEnumerableApiResultSuccess,
    PlanItemModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class PlanItemsDataService implements CrudService<PlanItemModel, PlanItemModel> {
    getAll(query: CrudDataQuery<PlanItemModel>): Promise<CrudEnumerableResponse<PlanItemModel>> {
        return ApiService.api.getPlanItemBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<PlanItemBasicModel>): Promise<CrudEnumerableResponse<PlanItemBasicModel>> {
        return ApiService.api.getPlanItemBasicBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<PlanItemModel>> {
        return ApiService.api.getPlanItemById(id, params);
    }

    create(item: PlanItemModel, params?: RequestParams): Promise<CrudResponse<PlanItemModel>> {
        return ApiService.api.insertPlanItem(item, params);
    }

    update(item: PlanItemModel, params?: RequestParams): Promise<PlanItemModel> {
        return ApiService.api.updatePlanItem(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<PlanItemModel> {
        return ApiService.api.patchPlanItem(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<PlanItemModel>): Promise<CrudEnumerableResponse<PlanItemModel>> {
        return ApiService.api.deletePlanItems(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationPlanItem(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<PlanItemModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        return ApiService.api.exportRawItemBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    clone(item: PlanItemModel, params?: RequestParams): Promise<CrudResponse<PlanItemModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getPlanItemGroupped(query, params);
    }

}
